module.exports = __webpack_public_path__ + "static/heading-5cc06431d73e22f36cb5a7d8bf329b75.png";